import { DeviceNotificationsContent } from './DeviceNotificationsContent'
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog'
import { useInstallPrompt } from '@/hooks/useInstallPrompt'
import { usePushSubscription } from '@/hooks/usePushSubscription'

interface DeviceNotificationsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function DeviceNotificationsDialog({ open, onOpenChange }: DeviceNotificationsDialogProps) {
  const push = usePushSubscription()
  const install = useInstallPrompt()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[680px]">
        <DialogTitle className="sr-only">Device notifications</DialogTitle>
        <DialogDescription className="sr-only">Manage push notifications on this device</DialogDescription>
        <DeviceNotificationsContent push={push} install={install} />
      </DialogContent>
    </Dialog>
  )
}
